(function () {
  var cache = {};
  function getProduct(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) {
        if (!r.ok) throw r;
        return r.json();
      });
      cache[handle].catch(function () { delete cache[handle]; });
    }
    return cache[handle];
  }
  function pickVariant(p, el) {
    if (el.dataset.variantId) return Number(el.dataset.variantId);
    var colour = (el.dataset.colour || '').toLowerCase();
    var match = p.variants.filter(function (v) {
      return !colour || v.options.some(function (o) { return String(o).toLowerCase() === colour; });
    });
    var out = match.filter(function (v) { return !v.available; })[0] || match[0] || p.variants[0];
    return out.id;
  }
  /* This file loads async, so a tap can come before the Restock Rocket app is ready: wait for it */
  function whenApp(ms) {
    return new Promise(function (resolve, reject) {
      var end = Date.now() + ms;
      (function check() {
        var rr = window._RestockRocket;
        if (rr && typeof rr.openModal === 'function') return resolve(rr);
        if (Date.now() > end) return reject();
        setTimeout(check, 100);
      })();
    });
  }
  function whenFormShows(ms) {
    return new Promise(function (resolve) {
      var end = Date.now() + ms;
      (function check() {
        var f = document.getElementById('formContainer');
        if ((f && f.offsetParent) || Date.now() > end) return resolve();
        setTimeout(check, 100);
      })();
    });
  }

  /* First touch or hover: keep the link preloader off the product page and start loading the product data */
  function warm(e) {
    var el = e.target.closest && e.target.closest('[data-vc-notify]');
    if (!el || !el.dataset.handle) return;
    el.dataset.noInstant = '';
    getProduct(el.dataset.handle).catch(function () {});
  }
  document.addEventListener('touchstart', warm, { capture: true, passive: true });
  document.addEventListener('mouseover', warm, { capture: true, passive: true });
  document.addEventListener('mousedown', warm, true);

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-vc-notify]');
    if (!el || !el.dataset.handle) return;
    e.preventDefault();
    if (el.getAttribute('aria-busy') === 'true') return;
    el.setAttribute('aria-busy', 'true');
    Promise.all([getProduct(el.dataset.handle), whenApp(15000)])
      .then(function (res) {
        res[1].openModal(res[0], pickVariant(res[0], el));
        return whenFormShows(10000);
      })
      .then(function () { el.removeAttribute('aria-busy'); })
      .catch(function () { window.location.href = el.href; });
  });

  /* A sold-out colour picked on a grid card swaps that card's button for Notify me */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('color-swatch .color-swatcher');
    if (!sw) return;
    var card = sw.closest('color-swatch');
    var soldOut = sw.classList.contains('unavailable');
    var colour = sw.getAttribute('data-color') || '';
    card.querySelectorAll('.card__quick-add-container, .card__quick-add-container--desktop').forEach(function (box) {
      var link = box.querySelector('[data-vc-notify-colour]');
      if (soldOut && !link) {
        var btn = box.querySelector('[data-product-url]');
        var url = btn && btn.getAttribute('data-product-url');
        if (!url || url.indexOf('/products/') === -1) return;
        link = document.createElement('a');
        link.href = url;
        link.className = 'wt-button--full-width hero__button hero__button--secondary vc-notify-link';
        link.setAttribute('data-vc-notify', '');
        link.setAttribute('data-vc-notify-colour', '');
        link.dataset.handle = url.split('/products/')[1].split(/[?#]/)[0];
        link.innerHTML = '<span class="vc-notify-long">Notify me when available</span><span class="vc-notify-short">Notify me</span>';
        box.appendChild(link);
      }
      if (!link) return;
      link.dataset.colour = colour;
      link.setAttribute('aria-label', 'Notify me when available: ' + colour);
      link.hidden = !soldOut;
      Array.prototype.forEach.call(box.children, function (n) {
        if (n !== link) n.hidden = soldOut;
      });
    });
  });

  /* The round bell on card photos has no visible text: give it a hover tooltip */
  document.addEventListener('pointerover', function (e) {
    var bell = e.target.closest && e.target.closest('.vc-bag .vc-notify-link, .vcvt-card__notify');
    if (bell && !bell.title) bell.title = 'Notify me when back in stock';
  });
})();
